export default __webpack_public_path__ + "static/media/7202105.b494abb8.jpg";